// eslint-disable-next-line import/no-extraneous-dependencies
import { loadStripe } from '@stripe/stripe-js';

let stripePromise;
const getStripe = () => {
  if (!stripePromise) {
    stripePromise = loadStripe(
      `${process.env.REACT_APP_PUBLIC_STRIPE_PUBLISHABLE_KEY}`,
    );
  }
  return stripePromise;
};

export default getStripe;
